/**
 * Build-time constants, injected from wrangler.toml's `[vars]` by
 * scripts/build.mjs (and by vitest.config.ts for tests) so that the browser
 * bundle and the Worker cannot disagree about the slug or the Hub's origin.
 *
 * These are replaced textually at build time, so they must never be renamed
 * without updating scripts/lib/app-vars.mjs.
 */

declare const __HUB_URL__: string;
declare const __APP_SLUG__: string;

export const HUB_URL: string = __HUB_URL__;

/** Read off the JWT as `apps[APP_SLUG]` — the underscore form (§2.1). */
export const APP_SLUG: string = __APP_SLUG__;
